
function Features(){
    return (
        <section className="bg-light py-5">
        <div className="container">
          <div className="row justify-content-center text-center mb-3">
            <div className="col-lg-8 col-xl-7">
              <span className="text-muted">Features</span>
              <h2 className="display-5 fw-bold">Why Choose Our Open-Source Tools?</h2>
              <p className="lead">
                Empowering chip designers with cutting-edge, open-source tools for seamless development and innovation.
              </p>
            </div>
          </div>
          <div className="row g-5 justify-content-center"> {/* Centering the grid */}
            <div className="col-xl-3 col-lg-4 col-sm-6 text-center">
              <div className="text-muted">
                <i className="bi bi-cpu" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="mt-3">Advanced Chip Design</h5>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6 text-center">
              <div className="text-muted">
                <i className="bi bi-cloud-download" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="mt-3">Free & Open-Source</h5>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6 text-center">
              <div className="text-muted">
                <i className="bi bi-tools" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="mt-3">Customizable Workflows</h5>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6 text-center">
              <div className="text-muted">
                <i className="bi bi-people" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="mt-3">Community-Driven Development</h5>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6 text-center">
              <div className="text-muted">
                <i className="bi bi-graph-up" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="mt-3">Optimized for Performance</h5>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6 text-center">
              <div className="text-muted">
                <i className="bi bi-code-slash" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="mt-3">Seamless Integration</h5>
            </div>
          </div>
        </div>
      </section>
      
    )
}    
export default Features